import { Injectable, inject } from '@angular/core';
import { ServiceInventoryService } from 'libs/desktop/data-access/service-inventory/src/lib/store/service-inventory.service';
import { HomeFeedService } from './home-feed.service';
import { Subject, filter, takeUntil, tap } from 'rxjs';
import { ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { WelcomeVideoCardComponent } from './welcome-video-card/welcome-video-card.component';
import { HomeFeedSection } from './store/home-feed.model';

@Injectable({
  providedIn: 'root',
})
export class WelcomeVideoCardService {
  private _serviceInventory: ServiceInventoryService = inject(ServiceInventoryService);
  private _homeFeedService: HomeFeedService = inject(HomeFeedService);
  private _unsub$ = new Subject<void>();

  constructor() {
    this._serviceInventory
      .getService('video_welcome')
      .pipe(
        filter((service) => !!service),
        tap((service) => {
          switch (service.state) {
            case ServiceState.INITIAL:
              this.registerWelcomeVideoInitialCard();
              break;
            case ServiceState.MAINTENANCE:
              break;
            default:
              break;
          }
        }),
        takeUntil(this._unsub$)
      )
      .subscribe();
  }

  ngOnDestroy() {
    this._unsub$.unsubscribe();
  }

  registerWelcomeVideoInitialCard() {
    this._homeFeedService.registerHomeFeedCard({
      key: 'welcome-video',
      component: 'WelcomeVideoCardComponent',
      componentRef: WelcomeVideoCardComponent,
      data: null,
      order: 0,
      section: HomeFeedSection.PROMOTION,
    });
  }

  removeWelcomeVideoInitialCard() {
    this._homeFeedService.removeHomeFeedCard('welcome-video', HomeFeedSection.PROMOTION);
  }

  /** Register the welcome video card so it appears in the feed (e.g. for dev menu). */
  showWelcomeVideoCard() {
    this.registerWelcomeVideoInitialCard();
  }
}
